// RecomendacaoList.js
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Alert } from '@mui/material';
import RecomendacaoCard from './RecomendacaoCard';

export default function RecomendacaoList({ recomendacoes = [], onPreInscricao }) {
  if (!Array.isArray(recomendacoes) || recomendacoes.length === 0) {
    return (
      <Alert severity="info">
        Nenhuma recomendação encontrada. Atualize seu perfil para receber recomendações personalizadas.
      </Alert>
    );
  }

  return (
    <Grid container spacing={3}>
      {recomendacoes.map((recomendacao) => (
        <Grid item xs={12} md={6} key={recomendacao.cursoId}>
          <RecomendacaoCard 
            recomendacao={recomendacao} 
            onPreInscricao={onPreInscricao}
          />
        </Grid>
      ))}
    </Grid>
  );
}

RecomendacaoList.propTypes = {
  recomendacoes: PropTypes.arrayOf(
    PropTypes.shape({
      cursoId: PropTypes.number.isRequired,
    })
  ).isRequired,
  onPreInscricao: PropTypes.func.isRequired,
};
